module.exports = __webpack_public_path__ + "static/fonts/Fact-Condensed.b026644.ttf";